import React from 'react';
import { withFirebase } from './firebase.index';

const SignOutButton = (props) => {
    return <div onClick={() => props.firebase.doSignOut()}>Sign Out</div>
}

export default withFirebase(SignOutButton);